import { Box } from "@mui/material";
import styled from "styled-components";

interface HeaderStyledPropsType {
  iscenteraligned: boolean;
  hideDescription?: boolean;
}

export const HeaderStyled = styled(Box)<HeaderStyledPropsType>`
  .custom-content {
    display: grid;
    grid-template-columns: 1fr 150px;
    column-gap: 20px;
    .cta-wrapper {
      align-self: center;
    }
  }
  .back-icon {
    width: 28px;
    height: 28px;
    cursor: pointer;
    svg {
      width: 100%;
      height: 100%;
      display: block;
      color: var(--medium-gray-color);
    }
  }
  .title-wrapper {
    display: flex;
    justify-content: center;
    align-items: ${({ iscenteraligned }) =>
      iscenteraligned ? "center" : "flex-start"};
    flex-direction: column;
    row-gap: 8px;

    .description {
      font-size: 14px;
      line-height: 21px;
      display: block;
    }
    @media (max-width: 450px) {
      .description {
        display: none;
        display: ${({ hideDescription }) => {
          return hideDescription ? "none" : "block";
        }};
      }
    }
    .title {
      line-height: 36px;
    }

    @media (max-width: 768px) {
  }
  }
  .title-back-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 8px;
  }
`;
